import { render, staticRenderFns } from "./Cursos.vue?vue&type=template&id=8ab02c0c&scoped=true&"
import script from "./Cursos.vue?vue&type=script&lang=js&"
export * from "./Cursos.vue?vue&type=script&lang=js&"
import style0 from "./Cursos.vue?vue&type=style&index=0&id=8ab02c0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab02c0c",
  null
  
)

export default component.exports